/**
 * @class Meta
 *
 */
export class Meta {
	/**
	 * Allows for putting any key that is a string onto this object.
	 *
	 * @type any
	 */
	[key: string]: any | {};
}
